import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import jsPDF from 'jspdf';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Personal } from 'src/app/Models/personal/personal';
import { DataService } from 'src/app/Service/data.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-print-ventas-por-categoria-precios',
  templateUrl: './print-ventas-por-categoria-precios.component.html',
  styleUrls: ['./print-ventas-por-categoria-precios.component.css']
})
export class PrintVentasPorCategoriaPreciosComponent implements OnInit {

  constructor(private data: DataService, private reportViewer: ReportViewerService, private datePipe: DatePipe, private cdr: ChangeDetectorRef) { }
  mes: string = '1';
  idvende: string = '1';
  public detfactus: any[] = [];
  totalcantidad: number = 0;
  totalefectivo: number = 0;
  totalfise: number = 0;
  totalyape: number = 0;
  totaltarjetacredito: number = 0;
  totalcredito: number = 0;
  totalgeneral: number = 0;
  public personal: Personal = new Personal()
  public today = new Date();
  public fecinicio: any;
  public fecfin: any;
  public filtro: Filtro = new Filtro()
  public sucursal: number;
  ngOnInit() {
  }

  GetData() {
    this.data.GetFromValue('informe_ventas_zona', this.mes, this.sucursal.toString()).subscribe({
      next: (r: any) => {
        console.log('Respuesta reporte por zonas:', r);
        this.cdr.detectChanges();
          
          setTimeout(() => {
            // Generar el PDF
            const blob = this.printerVentasZonas(r);

            // Mostrar en el modal reutilizable
            if (blob) {
              const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
              this.reportViewer.mostrarPDF(
                blob,
                'Reporte de Ventas por Categoría de Precio',
                `reporte_ventas_zonas_${fecha}.pdf`
              );
            }
          }, 0);
      },
      error: (err: any) => {
        console.error("Error al obtener datos del reporte por zonas:", err);
      }
    });
  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  printerVentasZonas(ventasData: any[]): Blob | null {
    const doc = new jsPDF('portrait'); // Modo vertical ya que son pocas columnas
    const titulo = { text: 'REPORTE DE VENTAS POR CATEGORÍA DE PRECIO', x: 50, y: 20 };

    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);
      const lineY = titulo.y + 1;
      doc.setLineWidth(0.5);
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(10);
      doc.text(
        `Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`,
        10,
        30
      );
      doc.text(
        `Generado el día ${this.formatFecha(this.today, 'dd-MM-yyyy HH:mm')}`,
        10,
        36
      );
      doc.setFontSize(10);
    };

    // Preparar datos para la tabla
    const tableRows: any[] = [];
    const totales = {
      total_cantidad: 0,
      total_ventas: 0
    };

    ventasData.forEach((zona: any) => {
      const row: any[] = [];
      row.push(zona.idzona || '');
      row.push(zona.zona || '');
      row.push(zona.total_cantidad || 0);
      row.push(zona.total_ventas ? Number(zona.total_ventas).toFixed(2) : '0.00');

      totales.total_cantidad += (zona.total_cantidad || 0);
      totales.total_ventas += (zona.total_ventas || 0);

      tableRows.push(row);
    });

    // Agregar fila de totales
    const rowTotal: any[] = [];
    rowTotal.push('');
    rowTotal.push('TOTAL');
    rowTotal.push(totales.total_cantidad);
    rowTotal.push(totales.total_ventas.toFixed(2));
    tableRows.push(rowTotal);

    // Configurar encabezados de la tabla
    const headers = [
      { content: 'ID', styles: { halign: 'center' } },
      { content: 'CATEGORÍA DE PRECIO', styles: { halign: 'center' } },
      { content: 'CANTIDAD TOTAL', styles: { halign: 'center' } },
      { content: 'VENTAS TOTALES (S/)', styles: { halign: 'center' } }
    ];

    // Configurar estilos de columnas
    const columnStyles: any = {
      0: { halign: 'center', cellWidth: 20 },
      1: { halign: 'left', cellWidth: 80 },
      2: { halign: 'right', cellWidth: 40 },
      3: { halign: 'right', cellWidth: 45 }
    };

    (doc as any).autoTable({
      head: [headers],
      body: tableRows,
      startY: 42,
      margin: { horizontal: 10 },
      theme: 'grid',
      columnStyles,
      styles: {
        fontSize: 10,
        cellPadding: 3,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        fontSize: 10
      },
      didParseCell: (data: any) => {
        // Resaltar la fila de totales
        if (data.row.index === tableRows.length - 1 && data.section === 'body') {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = [240, 240, 240];
        }
      },
      didDrawPage: (data: any) => {
        addHeader();
        const pageNumber = data.pageNumber;
        doc.text(`Página ${pageNumber}`, 180, 15);
      }
    });

    // Retornar el blob
    return doc.output('blob');
  }

}
